import autoCalculateDropdownBackdropHeight from "./autoCalculateDropdownBackdropHeight";
const setupCategoryMenu = () => {
    const resetDropdown = (dropdown) => {
        const items = dropdown.querySelectorAll('.dropdown-item');
        if(items.length > 0){
            items.forEach(it => {
                it.classList.remove('active');
                const siblingContainer = it.nextElementSibling;
                if(siblingContainer !== null){
                    siblingContainer.classList.remove('stoof-menu-cat-children--holder_active');
                }

            })
        }

    }
    if(document.querySelector('.dropdown-menu')){
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
       // const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
        const allDropdowns = document.querySelectorAll('.dropdown-menu');
        const toggler = document.querySelector('.navbar-toggler');
        if(vw > 1366){

            if(allDropdowns.length > 0){
                allDropdowns.forEach(drop => {
                    if(drop.querySelector('.stoof-menu-cat-children--holder')) {
                        const link = drop.querySelector('.dropdown-item');
                        drop.parentNode.addEventListener('shown.bs.dropdown', () => {
                            autoCalculateDropdownBackdropHeight();
                            resetDropdown(drop);
                            link.classList.add('active');
                            link.nextElementSibling.classList.add('stoof-menu-cat-children--holder_active');
                            link.focus();
                            document.addEventListener('click', ev => {
                                if(!ev.target.matches('.dropdown-item')) return;
                                ev.preventDefault();
                                ev.stopPropagation();
                                resetDropdown(drop);
                                ev.target.focus();
                                ev.target.classList.add('active');
                                ev.target.nextElementSibling.classList.add('stoof-menu-cat-children--holder_active');
                                autoCalculateDropdownBackdropHeight();
                            })
                        })
                        drop.parentNode.addEventListener('hidden.bs.dropdown', () => {
                            resetDropdown(drop);
                        })
                    }
                });
                document.addEventListener('click', ev =>{
                    if(!ev.target.closest('.stoof-menu-cat-children--wrapper')) return;
                    let menuToClose = ev.target.closest('.menu-item-has-children');
                    menuToClose.click();

                })
            }
        }
        if(vw < 1367){
            document.addEventListener('click', ev => {
                if(!ev.target.matches('.nav-link') || ev.target.parentNode.classList.contains('menu-item-has-children')) return;

                    if(!toggler.classList.contains('collapsed')){
                        toggler.click();
                    }
            })
        }


    }
}
export default setupCategoryMenu;
